module.exports = __webpack_public_path__ + "static/media/modal-back.6b93ed20.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/icons/modal-back.svg
// module id = 813
// module chunks = 0